import { z } from 'zod'

/** Response-only: replay loads current authorized state without another write. */
export const FinancialCommandResultSchema = z.object({
  operationId: z.string().uuid(),
  replayed: z.boolean(),
})
export type FinancialCommandResult = z.infer<
  typeof FinancialCommandResultSchema
>

/** Terminal closure is returned only after it competes with the original operation.
 * CANCELLED means that identity cannot later apply; APPLIED confirms its durable receipt.
 */
export const FinancialCommandClosureSchema = z.object({
  operationId: z.string().uuid(),
  organizationId: z.string().uuid(),
  userId: z.string().uuid(),
  targetId: z.string().uuid(),
  action: z.enum([
    'expense.reimburse',
    'contractor-invoice.mark-paid',
    'contractor-invoice.unmark-paid',
  ]),
  outcome: z.enum(['APPLIED', 'CANCELLED']),
})
export type FinancialCommandClosure = z.infer<
  typeof FinancialCommandClosureSchema
>
